import type { HeroSlide } from "../types/index";

export const heroSlides: HeroSlide[] = [
  {
    id: 1,
    title: "Discover New Zealand Your Way",
    subtitle:
      "Customizable itineraries, halal friendly options, and round the clock support for your perfect Kiwi adventure.",
    imageUrl: "/assets/IMG_8397.JPG",
    ctaText: "Explore Tours",
    ctaLink: "/tours",
  },
  {
    id: 2,
    title: "Your New Zealand Travel Experts",
    subtitle:
      "NZ based with Malaysian hospitality. We understand your needs and wants, providing a personalised service for your perfect Kiwi adventure.",
    imageUrl: "/assets/mountain-range.jpg",
    ctaText: "About Us",
    ctaLink: "/about",
  },
  {
    id: 3,
    title: "Adventure Awaits at Every Turn",
    subtitle:
      "From gentle city exploration to thrilling bungy jumping, from enjoying the scenery to helicopter rides. Activities tailored to your comfort and excitement level.",
    imageUrl: "/assets/queenstown-paraglide.jpg",
    ctaText: "View Activities",
    ctaLink: "/activities",
  },
  {
    id: 4,
    title: "Travel in Comfort & Style",
    subtitle:
      "Choose your perfect ride: self drive freedom, private driver convenience, or motorhome adventure. Modern vehicles with flexible rental options.",
    imageUrl: "/assets/294A170A-7EF9-4997-A149-266BBBFAAC5B_1_201_a.jpeg",
    ctaText: "Explore Vehicles",
    ctaLink: "/vehicles",
  },
];
